import {InstallationId} from "./nominalTypes/InstallationId";
import {TariffId} from "./nominalTypes/TariffId";

export const Ids = {
	Pittsburgh: {
		Id: "110008" as InstallationId,
		Tariffs: {
			VisitorPass: "110802" as TariffId,
			Residential: "110811" as TariffId,
			ResidentialPlusVisitor: "110812" as TariffId,
			ResidentialVisitorRight: "110813" as TariffId,
			Business: "110814" as TariffId,
			BusinessPlusVisitor: "110815" as TariffId,
			BusinessVisitorRight: "110816" as TariffId,
			Nanny: "110817" as TariffId,
			MedicalPass: "110818" as TariffId,
			Construction: "110819" as TariffId,
			OutOfService: "110820" as TariffId
		}
	},
	CoralGables: {
		Id: "110012" as InstallationId,
		Tariffs: {
			Residential: "111201" as TariffId,
			TemporaryResidential: "111202" as TariffId,
			Visitor1: "111203" as TariffId,
			Visitor2: "111204" as TariffId,
			Visitor3: "111205" as TariffId,
			Visitor4: "111206" as TariffId,

			MonthlyBV: "111221" as TariffId,
			MonthlyBVB: "111222" as TariffId,
			MonthlyBVP: "111223" as TariffId,
			MonthlyBVS: "111224" as TariffId,
			MonthlyGarage1: "111225" as TariffId,
			MonthlyGarage2: "111226" as TariffId,
			MonthlyGarage3: "111227" as TariffId,
			MonthlyGarage4: "111228" as TariffId,
			MonthlyGarage6: "111229" as TariffId,
			MonthlyLot1: "111230" as TariffId,
			MonthlyLot10: "111231" as TariffId,
			MonthlyLot12: "111232" as TariffId,
			MonthlyLot13: "111233" as TariffId,
			MonthlyLot14: "111234" as TariffId,
			MonthlyLot16: "111235" as TariffId,
			MonthlyLot17: "111236" as TariffId,
			MonthlyLot20: "111237" as TariffId,
			MonthlyLot21: "111238" as TariffId,
			MonthlyLot22: "111239" as TariffId,
			MonthlyLot23: "111240" as TariffId,
			MonthlyLot30: "111241" as TariffId,
			MonthlyLot31: "111242" as TariffId,
			MonthlyLot33: "111243" as TariffId,
			MonthlyLot36: "111244" as TariffId,
			MonthlyLot40: "111245" as TariffId,
			MonthlyLot43: "111246" as TariffId
		}
	},
	Gloucester: {
		Id: "110002" as InstallationId,
		Tariffs: {
			PassengerVehicle: "110201" as TariffId,
			Motorcycle: "110202" as TariffId
		}
	},
	GloucesterLongBeach: {
		Id: "110013" as InstallationId,
		Tariffs: {
			PassengerVehicle: "111301" as TariffId,
			Motorcycle: "111302" as TariffId
		}
	},
	Melbourne: {
		Id: "60003" as InstallationId,
		Tariffs: {
			MonthlyNonResident: "60302" as TariffId
		}
	},
	Sherbrooke: {
		Id: "40095" as InstallationId,
		Tariffs: {
			C1: "49514" as TariffId,
			C5: "49515" as TariffId,
			C6: "49532" as TariffId,
			D1: "49516" as TariffId,
			D1S: "49533" as TariffId,
			E: "49538" as TariffId,
			F: "49534" as TariffId,
			FL1: "49524" as TariffId,
			FL1C: "49511" as TariffId,
			FL2: "49525" as TariffId,
			G: "49517" as TariffId,
			H: "49518" as TariffId,
			J: "49519" as TariffId,
			J1S: "49535" as TariffId,
			M: "49536" as TariffId,
			MB1: "49526" as TariffId,
			MB1C: "49512" as TariffId,
			MB2: "49527" as TariffId,
			MB2C: "49513" as TariffId,
			MB3: "49528" as TariffId,
			MB4: "49529" as TariffId,
			MB5: "49530" as TariffId,
			QRESIDENT: "49522" as TariffId,
			QVISITEUR: "49523" as TariffId,
			R: "49520" as TariffId,
			STF: "49521" as TariffId,
			U: "49537" as TariffId,
			Z: "49531" as TariffId
		}
	},
	Gava: {
		Id: "2000004" as InstallationId,
		Tariffs: {
			SecondResidency: "308301" as TariffId,
			EconomicActivities: "308302" as TariffId
		}
	}
} as const;
